import React, {ChangeEventHandler} from 'react';
import Button from 'react-bootstrap/Button';
import {FormikProps} from 'formik';
import {FileToUpload} from './api';
import CustomModal from '../../../common/components/modal/CustomModal';
import AdminDocumentFormLogic from './AdminDocumentFormLogic';
import {useIntl} from 'react-intl';

interface AddDocumentModalProps {
    show: boolean;
    hide: () => void;
    formik: FormikProps<FileToUpload>;
    resetCategoryKey: number;
    fileOnChangeHandler: ChangeEventHandler;
}

const AddDocumentModal = ({
    show,
    hide,
    formik,
    resetCategoryKey,
    fileOnChangeHandler,
}: AddDocumentModalProps): JSX.Element => {
    const intl = useIntl();

    return (
        <CustomModal
            title={intl.formatMessage({id: 'ADMIN.DOCUMENTS.TITLE'})}
            show={show}
            onHide={hide}
            body={
                <AdminDocumentFormLogic
                    formik={formik}
                    fileOnChangeHandler={fileOnChangeHandler}
                    resetCategoryKey={resetCategoryKey}
                />
            }
            footer={
                <>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            hide();
                        }}
                    >
                        {intl.formatMessage({id: 'CANCEL'})}
                    </Button>
                    <Button
                        disabled={formik.isSubmitting || !formik.isValid}
                        variant="celeste-primary"
                        onClick={() => {
                            formik.submitForm();
                        }}
                    >
                        {intl.formatMessage({id: 'SEND'})}
                    </Button>
                </>
            }
        />
    );
};

export default AddDocumentModal;
